<app-custom-table class="ag-theme-material" class="collection-wrapper" [rowData]="gridApi_rapid_data"
    [columnDefs]="columnDefs_rapid" [hideGlobalFilter]="true" [animateRows]="true" [pagination]="true"
    [paginationPageSize]="20" (gridReady)="onGridReady($event)" [showLoader]="showLoader"
    (cellClicked)="onCellClicked($event)">
</app-custom-table>